<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <cadastro-toolbar
      :title="$t('crudAtendimentoConfig.title')"
      :token="token"
      hide-search
    />

    <v-tabs v-model="activeTab" background-color="transparent" color="primary" class="mt-2" show-arrows>
      <v-tab>{{ $t('crudAtendimentoConfig.tabs.familias') }}</v-tab>
      <v-tab>{{ $t('crudAtendimentoConfig.tabs.tipos') }}</v-tab>
      <v-tab>{{ $t('crudAtendimentoConfig.tabs.servicos') }}</v-tab>
    </v-tabs>

    <!-- v-show evita o offset do v-window em abas não-iniciais (Tipos/Serviços) -->
    <div v-show="activeTab === 0">
      <CRUDFamiliasAtendimento />
    </div>
    <div v-show="activeTab === 1">
      <CRUDTiposAtendimento />
    </div>
    <div v-show="activeTab === 2">
      <CRUDServicos />
    </div>
  </v-container>
</template>

<script>
import CRUDFamiliasAtendimento from './CRUDFamiliasAtendimento.vue';
import CRUDTiposAtendimento from './CRUDTiposAtendimento.vue';
import CRUDServicos from './CRUDServicos.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

const TAB_NAMES = ['familias', 'tipos', 'servicos'];

export default {
  name: 'CRUDAtendimentoConfig',
  components: {
    CRUDFamiliasAtendimento,
    CRUDTiposAtendimento,
    CRUDServicos,
    CadastroToolbar,
  },
  data: () => ({
    activeTab: 0,
    token: '',
  }),
  watch: {
    '$route.query.tab'(tabName) {
      const idx = TAB_NAMES.indexOf(tabName);
      if (idx !== -1) this.activeTab = idx;
    },
    activeTab(idx) {
      const name = TAB_NAMES[idx];
      if (this.$route.query.tab !== name) {
        this.$router.replace({ query: { ...this.$route.query, tab: name } }).catch(() => {});
      }
    },
  },
  created() {
    this.token = sessionStorage.getItem('api') || '';
    const tabName = this.$route.query.tab;
    const idx = TAB_NAMES.indexOf(tabName);
    if (idx !== -1) this.activeTab = idx;
  },
};
</script>
